<header [ngClass]="[styles.header, styles.containerFluid, themedBorder ? 'theme-primary-font-border-fade-50' : '']" flex-align="center" layout="row" layout-wrap="false">
	<h1 [ngClass]="styles.headerTitle" flex="fill">
		{{ headerText }}
	</h1>
	<div [ngClass]="styles.actions">
		<ng-content></ng-content>
	</div>
</header>